import Clarity from '@microsoft/clarity';
import * as Sentry from '@sentry/react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { routes } from './app/routes';
import './i18n';
import './styles.css';

Sentry.init({
  dsn: 'https://19f5248ef06d854e84f7b5a058d596de@o4510506914283520.ingest.de.sentry.io/4510506955702352',
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  tracesSampleRate: 1.0,
  // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/sellsen\.nsoft\.io\/api/],
});

const projectId = 'tfgaozakhh';

// ✅ Only initialize Clarity when NOT on localhost
if (
  typeof window !== 'undefined' &&
  window.location.hostname !== 'localhost' &&
  window.location.hostname !== '127.0.0.1'
) {
  Clarity.init(projectId);
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const client = new QueryClient();

root.render(
  <StrictMode>
    <QueryClientProvider client={client}>
      <RouterProvider router={routes} />
    </QueryClientProvider>
  </StrictMode>
);
